<template>
    <div class="locations-card locations-card--half" :class="modifier">
        <div class="locations-card__inner">
            <div class="locations-card__details">
                <a class="locations-card__title" :title="location.title" :href="location.url">{{ location.title }}</a>
                <div class="locations-card__address">{{ location.fullAddress }}</div>
                <p class="locations-card__phone" v-if="location.phone">D: <a :href="`tel:${location.phone}`">{{
                    location.phone }}</a></p>
            </div>
            <div class="locations-card__translations" v-if="location.hasCulture">{{ location.translationsAvailableLabel }}
            </div>
            <div class="locations-card__actions">
                <a :href="location.getDirectionsLink" target="_blank" v-if="location.fullAddress">Get directions</a>
                <VirtualTour v-if="location.virtualOfficeTourLink && modifier !== 'locations-card--info-window'"
                    :videoEmbedUrl="location.virtualOfficeTourLink" />
            </div>
        </div>
        <a :href="location.url" :title="location.title" class="locations-card__image"
            :style="`background-image: url(${location.heroImage});`"></a>
    </div>
</template>

<script>
import VirtualTour from "../Global/VirtualTour.vue"

export default {
    components: {
        VirtualTour
    },
    props: ["location", "modifier"],
    mounted() {
    },
    data() {
        return {

        }
    }
}
</script>

